// src/pages/Reports/IssuanceReporting/DistributionRecall/index.tsx
// README.md mục 7 — trang "Phân phối & Thu hồi": RPT-005 (phân phối), RPT-006 (chi tiết giao đại
// lý), RPT-007 (thu hồi vé), RPT-008 (chi tiết vé thu hồi). Chỉ đọc, không Redux slice riêng.

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import DistributionTab from './DistributionTab';
import DeliveryLinesTab from './DeliveryLinesTab';
import RecallSummaryTab from './RecallSummaryTab';
import RecallLinesTab from './RecallLinesTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'distribution' | 'deliveryLines' | 'recallSummary' | 'recallLines';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'distribution', label: st('phan_phoi_ve_label') },
  { key: 'deliveryLines', label: st('chi_tiet_giao_dai_ly_label') },
  { key: 'recallSummary', label: st('thu_hoi_ve_label') },
  { key: 'recallLines', label: st('chi_tiet_ve_thu_hoi_label') },
];

const DistributionRecallPage: React.FC = () => {
  useBrandingTitle(st('phan_phoi_thu_hoi_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('distribution');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('phan_phoi_thu_hoi_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'distribution' && <DistributionTab />}
            {activeTab === 'deliveryLines' && <DeliveryLinesTab />}
            {activeTab === 'recallSummary' && <RecallSummaryTab />}
            {activeTab === 'recallLines' && <RecallLinesTab />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default DistributionRecallPage;
